import React from "react";
import FeedbackForm from "@/components/FeedbackForm";
import { Lightbulb } from "lucide-react";

export default function Verbesserung() {
  return (
    <FeedbackForm
      kind="improvement"
      title="Verbesserungsvorschläge"
      subtitle="Was würde dir den Alltag leichter machen?"
      hero={{
        icon: Lightbulb,
        title: "Easy Gutachter wird besser — mit deiner Hilfe",
        headline: "Du nutzt Easy Gutachter täglich — sag uns, was fehlt.",
        description: "Wir lesen jeden Vorschlag persönlich. Beliebte Wünsche bauen wir zuerst — danke für dein Feedback!",
        gradient: "from-amber-500 to-orange-500",
      }}
      topics={["Gutachten-Vorlagen", "Zusatz-Felder im PDF", "Mobile-App (iOS/Android)", "Mehrsprachigkeit", "API für Buchhaltung"]}
      emptyState="Noch keine Vorschläge eingereicht."
      showPriority={false}
      testidPrefix="improvement"
    />
  );
}
